import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center flex-wrap uploaded-files"
}
const _hoisted_2 = {
  key: 0,
  class: "uploaded-file-wrapper"
}
const _hoisted_3 = {
  key: 1,
  class: "uploaded-file-wrapper"
}
const _hoisted_4 = {
  key: 2,
  class: "lh-1"
}
const _hoisted_5 = { class: "text-placeholder" }

import {__} from "~/ts/library/Translate";
import {
    KnowledgeBaseEssenceArticle
} from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaModelInterface";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import {computed, inject} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {LightboxInjection} from "~/core-ui/ts/LightboxInjection";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "AttachmentsList"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {model, uploadCount, lastSelectedTemplateText, site} = useTextareaComponent();

let lightbox = inject(LightboxInjection, null);


function clearSelectedTemplate() {
    if (model.value.text === lastSelectedTemplateText.value) {
        model.value.text = null;
    }
    model.value.templateId = null;
}

let selectedTemplateDescr = computed(() => {
    if (model.value.templateId) {
        let templatesData = OperatorAccountStore.getMessageTemplatesBySite(site.value.id);
        let template = templatesData.templates.find(template => template.id == model.value.templateId);
        return template ? template.descr : "Не найден";
    }
    return null;
});

let selectedBotDescr = computed(() => {
    if (model.value.botId) {
        let bot = site.value.bots.find(bot => bot.id == model.value.botId);
        return bot ? bot.descr : "Бот не найден";
    }
    return null;
});

function openAttach(name: string, url: string) {
    if (lightbox) {
        let imageExtensions = ["png", "jpg", "jpeg", "gif", "bmp"];
        for (let extension of imageExtensions) {
            if (name.endsWith(`.${extension}`)) {
                lightbox(url);
                return;
            }
        }
    }
    OperatorApplicationPlatform.openExternal(url);
}



return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_unref(model).files.length || _unref(uploadCount) > 0 || _unref(model).knowledgeBase.length || _unref(model).botId || _unref(model).templateId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(model).templateId)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_component_el_tag, {
                size: "small",
                type: "info",
                closable: "",
                onClose: clearSelectedTemplate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(__)("Шаблон")) + ": " + _toDisplayString(_unref(selectedTemplateDescr)), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(model).botId)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createVNode(_component_el_tag, {
                type: "info",
                size: "small",
                closable: "",
                onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(model).botId = null))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Запуск бота: " + _toDisplayString(_unref(selectedBotDescr)), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model).knowledgeBase, (article, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: i,
            class: "uploaded-file-wrapper"
          }, [
            _createVNode(_component_el_tag, {
              type: "info",
              size: "small",
              closable: "",
              onClose: ($event: any) => (_unref(model).knowledgeBase.splice(i, 1))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(article.essence == _unref(KnowledgeBaseEssenceArticle) ? _unref(__)("Статья") : _unref(__)("Группа статей")) + ": " + _toDisplayString(article.descr), 1)
              ]),
              _: 2
            }, 1032, ["onClose"])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model).files, (file, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: i,
            class: "uploaded-file-wrapper"
          }, [
            _withDirectives((_openBlock(), _createBlock(_component_el_tag, {
              type: "info",
              size: "small",
              class: "cursor-pointer",
              closable: "",
              onClose: ($event: any) => (_unref(model).files.splice(i, 1))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(file.name), 1)
              ]),
              _: 2
            }, 1032, ["onClose"])), [
              [_directive_on_native, () => openAttach(file.name, file.url), "click"]
            ])
          ]))
        }), 128)),
        (_unref(uploadCount) > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(MyLoader, { class: "mr-1" }),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(__)("Загрузка...")), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})